import { Link } from "react-router-dom";
import styled from "styled-components";

export const AccountLink = styled(Link)`
    text-decoration: none;
    margin-top: 1rem;
    width: 49%;

    @media (max-width: ${props => props.theme.maxWidth}) {
        width: 100%;
    }
`;
